import styled from "styled-components";
import ButtonComponent from "../Button";
import { motion } from "framer-motion";

export const Container = styled(motion.div)`
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999;
	background: rgba(0, 0, 0, 0.7);
	display: flex;
	align-items: center;
	justify-content: center;
	transform-style: preserve-3d;
	padding: 0 20px;
	opacity: 0;
`;

export const ContainerInner = styled(motion.div)`
	width: 100%;
	max-width: 700px;
	height: 500px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: var(--black-light);
	backdrop-filter: blur(12px);
	color: white;
	border-radius: 30px;
	position: relative;
	z-index: 5;
	transform-style: preserve-3d;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: inherit;
		padding: 2px;
		background: var(--gradient);
		mask: var(--gradient) content-box, var(--gradient);
		-webkit-mask: var(--gradient) content-box, var(--gradient);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
	}

	& > * {
		transform: translateZ(1px);
	}
`;

export const Icon = styled.div`
	font-size: 60px;
	color: white;
`;

export const Title = styled.h1`
	color: white;
	font-size: 40px;
`;

export const Message = styled.p`
	font-size: 16px;
	color: white;
	max-width: 400px;
	text-align: center;
	margin-top: 20px;
`;

export const Button = styled(ButtonComponent)`
	margin-top: 30px;
`;
